import React from 'react';

import LogoImage from '../assets/logo.png';

const Logo = () => {
  return (
    <div className="logo">
      <img className="logo-image" src={LogoImage} alt="Logo" />
      <div className="logo-title">
        {window.env.PAGE_TITLE}
      </div>
    </div>
  );
};

export default Logo;
